import { PartsProduct, Category } from '@app/react/const/type';

export const noProduct: PartsProduct = {
    id: -1,
    name: '加工なし',
    categoryId: -99,
    categoryName: '加工なし',
    subCategoryId: -999,
    subCategoryName: '加工なし',
    productImages: [
        '/html/template/default/assets/img/order/no_product.png',
        '/html/template/default/assets/img/order/no_product.png',
    ],
    textureImages: [],
    price: 0,
    options: {},
};

export const noProductCategory: Category = {
    categoryId: -99,
    categoryName: '加工なし',
    subCategoryData: [
        {
            subCategoryId: -999,
            subCategoryName: '加工なし',
        },
    ],
};
